// @ngInject
const config = ($stateProvider) => {
  $stateProvider.state('configuration.vdcTiers', {
    url: '/vdctiers',
    templateUrl: 'main/configuration/vdcTiers/vdcTiers.tpl.html',
    data: { pageTitle: 'VDC Tiers' },
  });
};

angular.module('configuration.vdcTiers', []).config(config);
